import {Document} from '../../document/models/document.models';

export class Category {
    /** @type {string} */
    _id = '';

    /** @type {string} */
    name = '';

    /** @type {boolean} */
    isActive = false;

    /** @type {boolean} */
    isTemplate = false;

    /** @type {array} */
    usersGroups = [];

    /** @type {Document[]} */
    documents = [];

    /** @type {Document[]} */
    companies = [];

    /**
     * @param {Object} obj
     * @returns {Category}
     */
    static fromArray(obj) {
        if (obj && obj.documents && obj.documents.length) {
            obj.documents = obj.documents.map(document => Document.fromArray(document));
        }

        return Object.assign(new this(), obj || {});
    }
}